import styled from 'styled-components'
import { Field } from 'formik'
import React from 'react'

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Label = styled.label`
  font-size: 14px;
  color: #555;
  margin-bottom: 8px;
  font-weight: 500;
`
export const Input = styled(Field)`
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  transition: border 0.2s ease;

  &:focus {
    border-color: #007bff;
    outline: none;
  }
`

const BaseTextInput = ({ children, label, name, placeholder, ...props }) => {
  return (
    <FieldWrapper>
      <Label htmlFor={name}>{label}</Label>
      <Input name={name} placeholder={placeholder} {...props} />
      {children}
    </FieldWrapper>
  )
}

export default BaseTextInput
